/* eslint-disable consistent-return */
export function groupYearFn(item: any) {
  if (item >= 2020 && item <= 2026) {
    return "2020 - 2026";
  } if (item >= 2010 && item <= 2019) {
    return "2010 - 2019";
  } if (item >= 2000 && item <= 2009) {
    return "2000 - 2009";
  } if (item >= 1990 && item <= 1999) {
    return "1990 - 1999";
  } if (item >= 1980 && item <= 1989) {
    return "1980 - 1989";
  } if (item >= 1970 && item <= 1979) {
    return "1970 - 1979";
  } if (item >= 1962 && item <= 1969) {
    return "1962 - 1969";
  }
}
